<template>
  <naj-box
    v-if="formModel.case.courtId !=null"
    :title="local.lawsuitDetails.similarCase.subTitle"
    :collapsed="false"
  >
    <fees-of-lawyer
      :form-model="formModel"
      :view-mode="viewMode"
      :type-id="similarCaseTypes.feesOfLawyer"
    ></fees-of-lawyer>
  </naj-box>
</template>

<script>
import feesOfLawyer from './fees-of-lawyer.vue';
import { similarCaseTypes } from '@/helpers/enum';

export default {
  inject: ['mode', '$validator'],
  components: { feesOfLawyer },
  props: {
    formModel: {
      type: Object,
      default: null,
    },
    viewMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return { similarCaseTypes };
  },

};
</script>
<style lang="scss" scoped>
</style>
